module.exports = __webpack_public_path__ + "static/media/solutions.80a2aa12.png";